import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import { WidgetContainer } from "./style";

const CONTAINER_ID = "walley-part-payment-container";

export const PartPaymentWidget = () => {
  const partPaymentWidget = useSelector(
    (state) => state.init.partPaymentWidget
  );
  const price = useSelector((state) => state.Result.Summary?.Price);
  const scriptRef = useRef(null);

  const amount = price ? Math.round(price * 100) : 0;
  const token = partPaymentWidget?.token;
  const scriptUrl = partPaymentWidget?.scriptUrl;
  const minPayment = partPaymentWidget?.minPayment;
  const maxPayment = partPaymentWidget?.maxPayment;

  const isInRange = amount >= minPayment && amount <= maxPayment;

  // Load the Walley loader script when token is available
  useEffect(() => {
    if (!token || !scriptUrl || !isInRange) return;

    const script = document.createElement("script");
    script.src = scriptUrl;
    script.dataset.token = token;
    script.dataset.widget = "part-payment";
    script.dataset.amount = String(amount);
    script.dataset.containerId = CONTAINER_ID;

    const container = document.getElementById(CONTAINER_ID);
    if (container) {
      container.appendChild(script);
    }

    scriptRef.current = script;

    return () => {
      if (scriptRef.current && scriptRef.current.parentNode) {
        scriptRef.current.parentNode.removeChild(scriptRef.current);
      }
      scriptRef.current = null;
    };
  }, [token, scriptUrl, isInRange]);

  // Update the widget when the amount changes
  useEffect(() => {
    if (scriptRef.current && amount > 0) {
      scriptRef.current.dataset.amount = String(amount);
      if (window.walley?.checkout?.api?.update) {
        window.walley.checkout.api.update();
      }
    }
  }, [amount]);

  if (!token || !isInRange) return null;

  return <WidgetContainer id={CONTAINER_ID} />;
};
